(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== "undefined" ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*******************!*\
  !*** ./loader.ts ***!
  \*******************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getEditorSDKurl: () => (/* binding */ getEditorSDKurl),
/* harmony export */   loadGAEditorSDK: () => (/* binding */ loadGAEditorSDK)
/* harmony export */ });
function getEditorSDKForVersion(version) {
  var urlBase = "https://static.parastorage.com/services/js-platform-editor-sdk/".concat(version, "/");
  return new URL('lib/editorSDK.min.js', urlBase).toString();
}
function isUrlAllowed(sdkVersion) {
  var url;
  try {
    url = new URL(sdkVersion);
  } catch (e) {
    return false;
  }
  var isLocalhost = url.hostname === 'localhost' || url.hostname.endsWith('.localhost');
  if (isLocalhost) {
    return true;
  }
  var isEditorSDKFromParastorage = url.hostname === 'static.parastorage.com' && url.protocol === 'https:' && (url.pathname.startsWith('/services/js-platform-editor-sdk/') || url.pathname.startsWith('/unpkg/@wix/platform-editor-sdk@'));
  if (isEditorSDKFromParastorage) {
    return true;
  }
  return false;
}
function getEditorSDKurl(currentUrl) {
  if (typeof currentUrl === 'string') {
    currentUrl = new URL(currentUrl);
  }
  var sdkVersion = currentUrl.searchParams.get('sdkVersion') || currentUrl.searchParams.get('wix-sdk-version');
  var editorSdkVersion = currentUrl.searchParams.get('editorSdkVersion');
  if (sdkVersion === null || sdkVersion === void 0 ? void 0 : sdkVersion.match(/^[0-9]+\.[0-9]+\.[0-9]+$/)) {
    return getEditorSDKForVersion(sdkVersion);
  } else if (sdkVersion && isUrlAllowed(sdkVersion)) {
    return new URL(sdkVersion).toString();
  } else if (editorSdkVersion === null || editorSdkVersion === void 0 ? void 0 : editorSdkVersion.match(/^[0-9]+\.[0-9]+\.[0-9]+$/)) {
    return getEditorSDKForVersion(editorSdkVersion);
  } else if (true) {
    return getEditorSDKForVersion("d0a1980cf31c8f0dac447d7261abb20a179d9448071f191f0a2b7edb");
  }
  // this should *never* happen, but in case it does...
  return getEditorSDKForVersion('1.1352.0');
}
function loadGAEditorSDK() {
  var editorSDKurl = getEditorSDKurl(new URL(self.location.href));
  return new Promise(function (resolve, reject) {
    if (window.editorSDK) {
      resolve(window.editorSDK);
      return;
    }
    var onload = function onload() {
      resolve(window.editorSDK);
    };
    var onerror = function onerror(event) {
      reject(new Error(event.error || event));
    };
    var existingScript = document.querySelector("script[src=\"".concat(editorSDKurl, "\"]"));
    if (existingScript) {
      existingScript.onload = onload;
      existingScript.onerror = onerror;
      return;
    }
    var script = document.createElement('script');
    script.onload = onload;
    script.onerror = onerror;
    script.src = editorSDKurl;
    document.body.appendChild(script);
  });
}

/******/ 	return __webpack_exports__;
/******/ })()
;
});